// NBL1_Player Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import Pay from "../Steps/Pay"

let step1, step2, step4, Countries, Associations, Events, Information, Message, DOB, EmailMessage

const PortalAgeCheck = p => v => {
    let Start = functions.FormatDate(v.DOB_Start, 'YYYY-MM-DD')
    let End = functions.FormatDate(v.DOB_End, 'YYYY-MM-DD')
    // console.log(Start, End, DOB)
    if (DOB < Start || DOB > End) {
        return 'Your Age does not qualify you for this Camp - Please select a Camp that matches your Age'
    }
    return true
}


// NBL1 Player Step Schema
const Load_BQ_Coach_Steps = () => {
    return {
        Portal: 'Basketball Queensland',
        MainColor: "#f5924c",
        Logo: require(`../../assets/BQLogo2.png`),
        Title: `<h2>Basketball Queensland Coach Registration Form</h2>`,
        Description: `Basketball Queensland is aimed at finding and developing Coaches that will operate across Queensland.`,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: `${Message}`,
                Schema: {
                    association: {
                        type: 'select',
                        label: 'Association',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Association is Required')],
                        class: 'mx-1 px-1',
                        items: Associations,
                        returnObject: true,
                        itemText: 'Detail',
                        value: '',
                    },
                    event: {
                        type: 'select',
                        label: 'Choose Event to Book',
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Event is Required')],
                        class: 'mx-1 px-1',
                        items: Events,
                        returnObject: true,
                        itemText: `description`,
                        col: 12,
                        value: '',
                        Role: 1,
                        onInput: (ev, portal) => {
                            // ev.obj.value.Association = ev.data.association.Code_id
                        },
                        OUG: { Bookings: true }
                    }
                },
                PreStep: (thisStep, portal) => { },
                PostStep: (thisStep, portal) => {
                    functions.sendEmail(
                        {
                            User_Name: 'BQ Coach Program',
                            User_Email: 'coachdev@basketballqld.net.au',
                            emailstosend: portal.Model.email,
                            Subject: `${portal.Model.event.title} Booking Confirmed`,
                            Message: `${EmailMessage[0].Terms}`
                        }
                    )
                },
            },
            // Step 4
            step4,
            // Step 5
            {
                stepno: 5,
                title: 'Finish',
                valid: true,
                information: `Thank you for your submitted registration for the Coaching Course.</br></br>
                If you have any queries regarding the program or your registration please contact <a href="mailto:coachdev@basketballqld.net.au">coachdev@basketballqld.net.au</a>`,
                Schema: {}
            }
        ]
    }
}



export default {

    LoadSchema: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        step4 = await Pay.LoadSchema(4)
        Countries = await functions.GetCountries()
        Associations = await functions.GetCodeBy({ Type: "Associations", Organisation: 292 }, true);
        Events = await functions.getData('SELECT * FROM events WHERE Team_id = 423 and start_date > NOW()', false);
        Events.forEach(event => {
            event.description = `${functions.FormatDate(event.start_date, 'ddd D MMM YYYY')} - ${event.title}`
        });
        EmailMessage = await functions.getData('SELECT Terms FROM Codes WHERE Code_id = 423', false);
        Information = await functions.getData("SELECT * FROM Codes_Messages WHERE Code_id = 423 AND Type = 'Information'", false)
        Message = Information[0].Messages
        return Load_BQ_Coach_Steps()
    },



}

